import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { AccountService } from "../../accounts/services/AccountService";
import { ComponentFields } from "../../core/services/ComponentService";
import { CRM_INTEGRATED_KEY, CUSTOMER_GROUP, ENABLE_POWER_BI_EMBEDDED_KEY, ENABLE_SET_TYPE_BUNDLE_KEY, POWER_BI_ANALYTICS_CONFIGURATION_KEY, POWER_PORTAL_BASE_URL_KEY } from "../../home/Consts";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { AGREEMENT_MAINTENANCE_GROUP, CONFIGURATION_PARAMETER_DEFAULT_DURATIONS_FOR_WORK_SOURCES, CONFIGURATION_PARAMETER_DEFAULT_SEARCH_VALUES, CONFIGURATION_PARAMETER_DEFAULT_SET_TYPE_GROUP, CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, CONFIGURATION_PARAMETER_PORTAL_WORK_STATUS_CONFIGURATION, CONFIGURATION_PARAMETER_SHARE_SETS_SHOWNS_IN_PORTAL, INGESTION_GROUP, PORTAL_CONFIGURATION_GROUP, WORK_MAINTENANCE_GROUP } from "../../membersportal/ConfigurationConsts";
import { ALL_REGISTERED_CUE_SHEET_PAGE, ALL_REGISTERED_WORKS_PAGE, CLAIMS_HISTORY_PAGE, CUE_SHEETS_MAINTENANCE_PAGE, DRAFT_AGREEMENTS_MAINTENANCE_PAGE, DRAFT_AGREEMENTS_PAGE, DRAFT_SET_LISTS_MAINTENANCE_PAGE, DRAFT_SET_LISTS_PAGE, DRAFT_WORKS_MAINTENANCE_PAGE, DRAFT_WORKS_PAGE, GENERIC_ERROR, LIVE_PERFORMANCE_MAINTENANCE_PAGE, LIVE_PERFORMANCE_SUBMISSION_PAGE, MEMBER_STATEMENTS_DETAILS_PAGE, MEMBER_STATEMENTS_PAGE, MY_DRAFT_CUE_SHEET_PAGE, MY_REGISTERED_CUE_SHEET_PAGE, REGISTERED_AGREEMENTS_PAGE, REGISTERED_SET_LISTS_PAGE, REGISTERED_WORKS_PAGE, REGISTERED_WORKS_VIEW_PAGE, UNPAID_CLAIMS_PAGE } from "../../membersportal/Consts";
import { MembersPortalAgreementValidator } from "../../membersportal/services/MembersPortalAgreementValidator";
import { MembersPortalLivePerformanceValidator } from "../../membersportal/services/MembersPortalLivePerformanceValidator";
import { MembersPortalSetListsValidator } from "../../membersportal/services/MembersPortalSetListsValidator";
import { MembersPortalWorkValidator } from "../../membersportal/services/MembersPortalWorkValidator";
import { SearchRequests } from "../../membersportal/services/SearchRequests";
import { StorageRequests } from "../../membersportal/services/StorageRequests";
import { IAllRegisteredWorkSearchQuery } from "../../membersportal/types/IAllRegisteredWorkSearchQuery";
import { IAllRegisteredWorkSearchResult } from "../../membersportal/types/IAllRegisteredWorkSearchResult";
import { IApplication } from "../../membersportal/types/IApplication";
import { ICase } from "../../membersportal/types/ICase";
import { IClaimUnidentifiedClaimModal } from "../../membersportal/types/IClaimUnidentifiedClaimModal";
import { IClaimsHistorySearchQuery, IClaimsHistorySearchResult } from "../../membersportal/types/IClaimsHistorySearchQuery";
import { ICueSheetsSearchQuery } from "../../membersportal/types/ICueSheetsSearchQuery";
import { IDraftAgreementSearchQuery } from "../../membersportal/types/IDraftAgreementSearchQuery";
import { IDraftAgreementSearchResult } from "../../membersportal/types/IDraftAgreementsSearchResult";
import { IDraftSetListSearchQuery } from "../../membersportal/types/IDraftSetListSearchQuery";
import { IDraftSetListSearchResult } from "../../membersportal/types/IDraftSetListSearchResult";
import { IDraftWorkSearchQuery } from "../../membersportal/types/IDraftWorkSearchQuery";
import { IDraftWorkSearchResult } from "../../membersportal/types/IDraftWorkSearchResult";
import { ILivePerformanceSearchQuery } from "../../membersportal/types/ILivePerformanceSearchQuery";
import { ILivePerformancesSearchResult } from "../../membersportal/types/ILivePerformancesSearchResult";
import { IMemberStatementSearchQuery } from "../../membersportal/types/IMemberStatementSearchQuery";
import { IMemberStatementPaymentRunWork, IMemberStatementSearchResult } from "../../membersportal/types/IMemberStatementSearchResult";
import { IMembersPortalField } from "../../membersportal/types/IMembersPortalField";
import { IMembersPortalPathInfo } from "../../membersportal/types/IMembersPortalPathInfo";
import { IRegisteredAgreementSearchQuery } from "../../membersportal/types/IRegisteredAgreementSearchQuery";
import { IRegisteredAgreementSearchResult } from "../../membersportal/types/IRegisteredAgreementSearchResult";
import { IRegisteredSetListsSearchQuery } from "../../membersportal/types/IRegisteredSetListsSearchQuery";
import { IRegisteredSetListsSearchResults } from "../../membersportal/types/IRegisteredSetListsSearchResults";
import { IRegisteredWorkSearchQuery } from "../../membersportal/types/IRegisteredWorkSearchQuery";
import { IRegisteredWorkSearchResult } from "../../membersportal/types/IRegisteredWorkSearchResult";
import { IUnpaidClaimsSearchQuery } from "../../membersportal/types/IUnpaidClaimsSearchQuery";
import { IUnpaidClaimsSearchResult } from "../../membersportal/types/IUnpaidClaimsSearchResult";
import { IViewAsAccessRequest } from "../../membersportal/types/IViewAsAccessRequest";
import { CONFIGURATION_PARAMETER_IS_APPLIED_AT_IP_NAME_NUMBER_LEVEL_KEY, CONFIGURATION_PARAMETER_SHARE_DECIMALS_TO_DISPLAY, CONFIGURATION_PARAMETER_SUBMITTER_MUST_BE_ASSOCIATED_FIELDS_KEY, CONFIGURATION_PARAMETER_USERELATIONSHIPS_KEY } from "../../repertoire/ConfigurationConsts";
import { DEFINITE_MATCH, MY_PACKAGES_PAGE, SET_LIST_TYPE, WORK_NOT_FOUND_VIEW } from "../../repertoire/Consts";
import { AgreementDetailsMapper } from "../../repertoire/services/AgreementDetailsMapper";
import { ProductDetailsMapper } from "../../repertoire/services/ProductDetailsMapper";
import { SearchRequests as RepertoireSearchRequests } from '../../repertoire/services/SearchRequests';
import { UserPreferencesService } from "../../repertoire/services/UserPreferencesService";
import { WorkDetailsMapper } from "../../repertoire/services/WorkDetailsMapper";
import { UsageDetailsMapper } from "../../repertoire/services/usageServices/UsageDetailsMapper";
import { DataSource } from "../../repertoire/types/DataSource";
import { IAgreement } from "../../repertoire/types/IAgreement";
import { IAgreementSaveResult } from "../../repertoire/types/IAgreementSaveResult";
import { IArtist } from "../../repertoire/types/IArtist";
import { IArtistSearchQuery } from "../../repertoire/types/IArtistSearchQuery";
import { IContributorItem } from "../../repertoire/types/IContributorItem";
import { IContributorSearchQuery } from "../../repertoire/types/IContributorSearchQuery";
import { IContributorSearchResult } from "../../repertoire/types/IContributorSearchResult";
import { IIPsSearchQuery } from "../../repertoire/types/IIPsSearchQuery";
import { IIPsSearchResult } from "../../repertoire/types/IIPsSearchResult";
import { IP } from "../../repertoire/types/IP";
import { IProductCore } from "../../repertoire/types/IProductCore";
import { IProductSaveResult } from "../../repertoire/types/IProductSaveResult";
import { IProductWork } from "../../repertoire/types/IProductWork";
import { IValidationMessage } from "../../repertoire/types/IValidationMessage";
import { IWork } from "../../repertoire/types/IWork";
import { IWorkSaveResult } from "../../repertoire/types/IWorkSaveResult";
import { IWorksSearchQuery } from "../../repertoire/types/IWorksSearchQuery";
import { IWorksSearchResult } from "../../repertoire/types/IWorksSearchResult";
import { IMatchWorksSearchQuery } from "../../repertoire/types/usageTypes/IMatchWorksSearchQuery";
import { IMatchWorksSearchResult } from "../../repertoire/types/usageTypes/IMatchWorksSearchResult";
import { IUsageGroup } from "../../repertoire/types/usageTypes/IUsageGroup";
import { IUsageSaveResult } from "../../repertoire/types/usageTypes/IUsageSaveResult";
import { getUploadCueSheetsFilesRequest } from "../reducers/DataIngestionReducer";
import {
    cancelAccessRequest, cancelAccessRequestFailure, cancelAccessRequestSuccess,
    claimUnpaidUsageFailure,
    claimUnpaidUsageRequest, claimUnpaidUsageSuccess,
    createNewDraftAgreement,
    createNewDraftLivePerformance,
    createNewDraftSetLists, createNewDraftWork,
    deleteDraftSetListFailure, deleteDraftSetListRequest,
    deleteDraftSetListSuccess, deleteDraftWorkFailure, deleteDraftWorkRequest, deleteDraftWorkSuccess, deleteRegisteredWorkFailure, deleteRegisteredWorkRequest, deleteRegisteredWorkSuccess, getAllRegisteredWorkDetailsFailure, getAllRegisteredWorkDetailsRequest,
    getAllRegisteredWorkDetailsSuccess,
    getCRMIntegratedEnabledFailure,
    getCRMIntegratedEnabledSuccess,
    getCRMPowerPortalURLSuccess,
    getCueSheetsDetailsFailure,
    getCueSheetsDetailsRequest,
    getCueSheetsDetailsSuccess,
    getDefaultIsAppliedAtIPNameNumberLevelflagSuccess,
    getDefaultUseRelationshipflagSuccess,
    getDraftAgreementDetailsFailure,
    getDraftAgreementDetailsRequest,
    getDraftAgreementDetailsSuccess,
    getDraftSetListDetailsFailure, getDraftSetListDetailsRequest,
    getDraftSetListDetailsSuccess, getDraftWorkDetailsFailure, getDraftWorkDetailsRequest,
    getDraftWorkDetailsSuccess,
    getEnabledSetTypeBundleFailure,
    getEnabledSetTypeBundleRequest,
    getEnabledSetTypeBundleSuccess,
    getLivePerformanceDetailsFailure,
    getLivePerformanceDetailsSuccess,
    getMembersPortalComponentDataFailure, getMembersPortalComponentDataRequest,
    getMembersPortalComponentDataSuccess, getMemberStatementDetailsFailure,
    getMyApplications,
    getMyApplicationsFailure,
    getMyApplicationsSuccess,
    getMyCases,
    getMyCasesFailure,
    getMyCasesSuccess,
    getRegisteredWorkDetailsFailure, getRegisteredWorkDetailsRequest,
    getRegisteredWorkDetailsSuccess,
    getShareDecimalsToDisplayFailure,
    getShareDecimalsToDisplayRequest,
    getShareDecimalsToDisplaySuccess,
    getUserPreferenceFailure, getUserPreferenceRequest,
    getUserPreferenceSuccess, getViewAsAccessRequests, getViewAsAccessRequestsFailure, getViewAsAccessRequestsSuccess, mp_addTab, mp_openTab, mp_removeTab,
    refreshAgreementDetailsFailure,
    refreshAgreementDetailsRequest,
    refreshAgreementDetailsSuccess,
    refreshWorkDetailsFailure,
    refreshWorkDetailsRequest,
    refreshWorkDetailsSuccess,
    removeAgreementAttachmentFailure, removeAgreementAttachmentRequest,
    removeAgreementAttachmentSuccess,
    removeWorkAttachmentFailure, removeWorkAttachmentRequest,
    removeWorkAttachmentSuccess,
    replaceTab,
    requestViewAsAccess, requestViewAsAccessFailure, requestViewAsAccessSuccess,
    saveContributorComment,
    saveDraftAgreementFailure,
    saveDraftAgreementSuccess,
    saveDraftLivePerformanceFailure, saveDraftLivePerformanceSuccess, saveDraftSetListsFailure,
    saveDraftSetListSuccess, saveDraftWorkFailure, saveDraftWorkRequest, saveDraftWorkSuccess, saveRegisteredWorkFailure, saveRegisteredWorkRequest, saveRegisteredWorkSuccess, saveViewAsAccess, saveViewAsAccessFailure, saveViewAsAccessSuccess, searchAllRegisteredWorksFailure, searchAllRegisteredWorksRequest,
    searchAllRegisteredWorksSuccess, searchArtistsFailure, searchArtistsRequest,
    searchArtistsSuccess,
    searchClaimsHistoryFailure,
    searchClaimsHistoryRequest, searchClaimsHistorySuccess,
    searchContributorsFailure, searchContributorsRequest,
    searchContributorsSuccess,
    searchCueSheetsFailure,
    searchCueSheetsRequest,
    searchCueSheetsSuccess,
    searchDraftAgreementsFailure,
    searchDraftAgreementsIPFailure,
    searchDraftAgreementsIPRequest,
    searchDraftAgreementsIPSuccess,
    searchDraftAgreementsRequest,
    searchDraftAgreementsSuccess,
    searchDraftAgreementsWorksFailure,
    searchDraftAgreementsWorksRequest,
    searchDraftAgreementsWorksSuccess,
    searchDraftSetListsFailure, searchDraftSetListsRequest,
    searchDraftSetListsSuccess, searchDraftWorksFailure, searchDraftWorksRequest,
    searchDraftWorksSuccess,
    searchLivePerformancesSuccess,
    searchMemberStatementsFailure, searchMemberStatementsRequest,
    searchMemberStatementsSuccess,
    searchRegisteredAgreementsFailure,
    searchRegisteredAgreementsRequest,
    searchRegisteredAgreementsSuccess,
    searchRegisteredSetListsFailure, searchRegisteredSetListsRequest,
    searchRegisteredSetListsSuccess, searchRegisteredWorksFailure, searchRegisteredWorksRequest, searchRegisteredWorksSuccess, searchRequestAccessIPRequest, searchRequestAccessIPRequestFailure, searchRequestAccessIPRequestSuccess,
    searchUnpaidClaimsFailure,
    searchUnpaidClaimsRequest,
    searchUnpaidClaimsSuccess,
    showModal,
    undoDraftSetListChangesFailure, undoDraftSetListChangesRequest, undoDraftSetListChangesSuccess, undoDraftWorkChangesFailure, undoDraftWorkChangesRequest,
    undoDraftWorkChangesSuccess, undoRegisteredWorkChangesFailure, undoRegisteredWorkChangesRequest,
    undoRegisteredWorkChangesSuccess, updateFieldComponentRequest, updateFieldComponentRequestFailure,
    updateFieldComponentRequestSuccess, updateWorkContributorIPFailure, updateWorkContributorIPRequest,
    updateWorkContributorIPSuccess,
    getSetListWorkDefaultDurationConfigRequest,
    getSetListWorkDefaultDurationConfigSuccess,
    getSetListWorkDefaultDurationConfigFailure,
    getWorkContributorDefaultLegalEntityValueRequest,
    getWorkContributorDefaultLegalEntityValueSuccess,
    getWorkContributorDefaultLegalEntityValueFailure,
    getShareSetsShownInPortalRequest,
    getShareSetsShownInPortalFailure,
    getShareSetsShownInPortalSuccess,
    uploadCueSheetsFiles,
    searchLicenseVenuesRequest,
    searchLicenseVenuesSuccess,
    searchLicensVenuesFailure,
    getAssigneeAgreementsRequest,
    getAssigneeAgreementsSuccess,
    getAssigneeAgreementsFailure,
    getMemberStatementPowerBiEmbedSuccess,
    getMemberStatementPowerBiEmbedFailure,
    getMemberStatementPowerBiEmbedRequest,
    resetPowerBiEmbedToken,
    getFullCataloguePackagePendingFailure,
    getFullCataloguePackagePendingSuccess,
    createPackageFromCriteriaSuccess,
    createPackageFromCriteriaFailure,
    getMemberStatementDetailsSuccess,
    getPowerBIConfigurationSuccess,
    getPowerBIConfigurationFailure,
    getDefaultSetTypeGroupRequest,
    getDefaultSetTypeGroupSuccess,
    getDefaultSetTypeGroupFailure,
    createPackageFromCriteriaRequest,
    searchLivePerformancesFailure,
    searchLivePerformancesRequest,
    getPortalWorkStatusConfigurationFailure,
    getPortalWorkStatusConfigurationSuccess
} from "../reducers/MembersPortalReducer";
import { hideModal, showLoading } from "../reducers/ModalReducer";
import { searchLastPercentageFailure } from "../reducers/RepertoireReducer";
import { MembersPortalService } from "../services/MembersPortalService";
import { RepertoireService } from "../services/RepertoireService";
import { FormatFields } from "../types/FormatFields";
import { IAddWorkAttachmentModel } from "../types/IAddAttchmentWorkModel";
import { IAddAgreementAttachmentModel } from "../types/IAddAttchmentAgreementModel";
import { IAgreementState } from "../types/IAgreementState";
import IAppState from "../types/IAppState";
import { IAttachedFile } from "../types/IAttachedFile";
import IMembersPortalComponentData from "../types/IMembersPortalComponentData";
import IMembersPortalComponentDataItem from "../types/IMembersPortalComponentDataItem";
import { IMembersPortalRoleAssignment } from "../types/IMembersPortalRoleAssignment";
import { IProductState } from "../types/IProductState";
import { ITabReduxItem } from "../types/ITabReduxItem";
import { IUsageGroupState } from "../types/IUsageGroupState";
import { IWorkState } from "../types/IWorkState";
import { IPortalShareSetConfiguration } from "../../membersportal/types/IPortalShareSetConfiguration";
import { ILicenseVenueSearchQuery } from "../../repertoire/types/ILicenseVenueSearchQuery";
import { ILicenseCustomerVenue } from "../../repertoire/types/ILicenseCustomerVenue";
import { IAssigneeAgreementResult } from "../../membersportal/types/IAssigneeAgreementResult";
import { IApplicableWorkSearchQuery } from "../../repertoire/types/IApplicableWorkSearchQuery";
import { IAgreementWork } from "../../repertoire/types/IAgreementWork";
import { IAddtoPackageResult } from "../../repertoire/types/IAddtoPackageResult";
import { IPowerBIAnalyticsConfig } from "../../membersportal/types/IPowerBIAnalyticsConfig";
import { setCurrentUserNameNumber } from "../reducers/AccountReducer";
import { setAccountSocietyAffiliation } from "../reducers/AccountReducer";
import { searchLookupValueByCode } from "../../lookup/services/LookupHelpers";
import { WORK_STATUS_LOOKUP } from "../../lookup/Consts";
import { getMenuItemsThunk } from "./HomeThunks";
import { IAccountSocietyAffiliation } from "../../membersportal/types/IAccountSocietyAffiliation";
import { getUserCRMValuesThunk } from "./AccountThunks";
import { DEFAULT_ACCOUNT_NUMBER, DEFAULT_GUID, DEFAULT_IP_BASE_NUMBER, DEFAULT_IP_NAME_NUMBER } from "../../accounts/Consts";
import { hasAnyValidValue } from "../../util/tools";
import { IRequestViewAsAccessModel } from "../../membersportal/types/IRequestViewAsAccessModel";
import { IPortalWorkStatusConfiguration } from "../../membersportal/types/IPortalWorkStatusConfiguration";

export const getMembersPortalComponentDataThunk = (): ThunkAction<
    void,
    IAppState,
    null,
    Action<string>
> => {
    return (dispatch: Dispatch) => {
        dispatch(getMembersPortalComponentDataRequest());
        return ComponentFields.getMembersPortalComponentData()
            .then((res: IMembersPortalComponentData) => {
                dispatch(getMembersPortalComponentDataSuccess(res));
            })
            .catch((error: any) => {
                dispatch(getMembersPortalComponentDataFailure(error));
            });
    };
};


export const undoDraftWorkChangesThunk = (
    dataSource: string,
    workID: number,
    lookups: ILookupDictionary
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(undoDraftWorkChangesRequest());
        dispatch(showLoading());
        return SearchRequests.getDraftWork(dataSource, workID)
            .then((work: IWork) => {
                dispatch(undoDraftWorkChangesSuccess(work, lookups));
                dispatch(hideModal());
            })
            .catch(err => {
                dispatch(undoDraftWorkChangesFailure(err));
                dispatch(hideModal());
            });
    };
};
export const searchLicenseVenuesThunk = (
    licenseVenue: ILicenseVenueSearchQuery,
    dataSource: string,
    keepModalOpenAfterSearch?: boolean,
    lookups?: ILookupDictionary
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(searchLicenseVenuesRequest());
        if (!keepModalOpenAfterSearch)
            dispatch(showLoading());
        return SearchRequests.getLicenseVenues(licenseVenue, dataSource)
            .then((res: ILicenseCustomerVenue[]) => {
                dispatch(searchLicenseVenuesSuccess(res));
            })
            .catch(err => {
                dispatch(searchLicensVenuesFailure(err));
                if (!keepModalOpenAfterSearch)
                    dispatch(hideModal());
            });
    };


};
export const undoDraftSetListChangesThunk = (
    dataSource: string,
    setListID: number,
    lookups: ILookupDictionary
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(undoDraftSetListChangesRequest());
        dispatch(showLoading());
        return SearchRequests.getGetProductDetails(dataSource, setListID)
            .then((setList: IProductCore) => {
                dispatch(undoDraftSetListChangesSuccess(setList, lookups));
                dispatch(hideModal());
            })
            .catch(err => {
                dispatch(undoDraftSetListChangesFailure(err));
                dispatch(hideModal());
            });
    };


};

export const undoRegisteredWorkChangesThunk = (
    dataSource: string,
    workID: number,
    lookups: ILookupDictionary
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(undoRegisteredWorkChangesRequest());
        dispatch(showLoading());
        return SearchRequests.getRegisteredWork(dataSource, workID)
            .then((work: IWork) => {
                dispatch(undoRegisteredWorkChangesSuccess(work, lookups));
                dispatch(hideModal());
            })
            .catch(err => {
                dispatch(undoRegisteredWorkChangesFailure(err));
                dispatch(hideModal());
            });
    };
}

export const updateComponentFieldItemsThunk = (
    fields: IMembersPortalField[],
    componentName: string,
    componentInstance: string,
    componentDataFieldName: string,
    tabs: ITabReduxItem[],
    activeTab: number,
): ThunkAction<
    void,
    IAppState,
    null,
    Action<string>> => {

    return (dispatch: Dispatch) => {
        dispatch(showLoading());
        dispatch(updateFieldComponentRequest());
        return ComponentFields.updateMembersPortalComponentFieldItem(fields, componentName, componentInstance)
            .then((res: IMembersPortalField[]) => {
                if (res) {
                    dispatch(updateFieldComponentRequestSuccess(res, componentDataFieldName, componentInstance));
                    // remove tab and add it back in to force components to re-mount and reload ViewData
                    dispatch(mp_removeTab(activeTab));
                    dispatch(mp_addTab(tabs[activeTab], true));
                    dispatch(hideModal());
                }
            })
            .catch(error => {
                updateFieldComponentRequestFailure(error);
            });
    }
}

export const getDefaultUseRelationshipflagThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_USERELATIONSHIPS_KEY, AGREEMENT_MAINTENANCE_GROUP)
            .then(res => {
                dispatch(getDefaultUseRelationshipflagSuccess(res));
            })
    };
};

export const getDefaultIsAppliedAtIPNameNumberLevelflagThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_IS_APPLIED_AT_IP_NAME_NUMBER_LEVEL_KEY, AGREEMENT_MAINTENANCE_GROUP)
            .then(res => {
                dispatch(getDefaultIsAppliedAtIPNameNumberLevelflagSuccess(res));
            })
    };
};

export const getDefaultSubmitterMustBeAssociatedWithAgreementflagThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_SUBMITTER_MUST_BE_ASSOCIATED_FIELDS_KEY, AGREEMENT_MAINTENANCE_GROUP)
            .then(res => {
                dispatch(getDefaultUseRelationshipflagSuccess(res));
            })
    };
};

export const getEnabledSetTypeBundleThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getEnabledSetTypeBundleRequest());
        return SearchRequests.getConfigurationParameter(ENABLE_SET_TYPE_BUNDLE_KEY, CUSTOMER_GROUP)
            .then((res: boolean) => {
                dispatch(getEnabledSetTypeBundleSuccess(res));
            })
            .catch((error: any) => {
                dispatch(getEnabledSetTypeBundleFailure(error));
            });
    }
}

export const getUserPreferences = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getUserPreferenceRequest())
        return UserPreferencesService.get()
            .then(res => {
                dispatch(getUserPreferenceSuccess(res.resultsPerPage, res.activeAccordions));
            })
            .catch(error => {
                dispatch(getUserPreferenceFailure());
                console.error(error);
            })
    }
}

export const searchMemberStatementsThunk =
    (statementsQuery: IMemberStatementSearchQuery): ThunkAction<void, IAppState, null, Action<string>> =>
        (dispatch: Dispatch) => {

            dispatch(searchMemberStatementsRequest());

            dispatch(showLoading());
            SearchRequests.getMemberStatements(statementsQuery)
                .then((res: IMemberStatementSearchResult[]) =>
                    StorageRequests.getStatementFiles(res)
                        .catch(err => {
                            if (err?.response?.status === 404) {
                                return res;
                            }
                            throw err;
                        })
                )
                .then((finalRes: IMemberStatementSearchResult[]) => {
                    dispatch(searchMemberStatementsSuccess(finalRes));
                })
                .catch(err => {
                    dispatch(searchMemberStatementsFailure(err));
                }).finally(() => {
                    dispatch(hideModal());
                });
        };


export const searchUnpaidClaimsThunk = (searchQuery: IUnpaidClaimsSearchQuery, continuationToken: string): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        searchQuery.isMembersPortal = true;
        dispatch(searchUnpaidClaimsRequest())
        SearchRequests.getUnpaidClaims(searchQuery, continuationToken)
            .then((res: IUnpaidClaimsSearchResult[]) => {
                dispatch(searchUnpaidClaimsSuccess(res));
            })
            .catch(err => {
                dispatch(searchUnpaidClaimsFailure(err));
            });
    }
}

export const claimUnpaidUsageThunk = (query: IClaimUnidentifiedClaimModal): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(claimUnpaidUsageRequest())
        SearchRequests.claimUnpaidUsage(query)
            .then((res: IUnpaidClaimsSearchResult[]) => {
                dispatch(claimUnpaidUsageSuccess());
            })
            .catch(err => {
                dispatch(claimUnpaidUsageFailure());
            });
    }
}

export const searchClaimsHistoryThunk = (searchQuery: IClaimsHistorySearchQuery, continuationToken: string): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        searchQuery.isMembersPortal = true;
        dispatch(searchClaimsHistoryRequest())
        SearchRequests.getClaimsHistory(searchQuery, continuationToken)
            .then((res: IClaimsHistorySearchResult[]) => {
                dispatch(searchClaimsHistorySuccess(res));
            })
            .catch(err => {
                dispatch(searchClaimsHistoryFailure(err));
            });
    }
}


export const searchDraftSetListsThunk = (
    setListQuery: IDraftSetListSearchQuery
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(searchDraftSetListsRequest());
        const searchMethod = setListQuery?.dataSource === 'Repertoire' ? 'ViewMyRegisteredSetLists' : 'ViewMyDraftSetLists';
        return SearchRequests.getSetLists(setListQuery, searchMethod)
            .then((result: IDraftSetListSearchResult[]) => {
                if (result == null || result.length == 0) {
                    dispatch(searchDraftSetListsSuccess([]));
                } else {
                    dispatch(searchDraftSetListsSuccess(result));
                }
            }).catch(err => {
                dispatch(searchDraftSetListsFailure(err));
            });
    };
};


export const searchDraftAgreementsThunk = (
    draftAgreementsQuery: IDraftAgreementSearchQuery,
    lookupValues: ILookupDictionary,
    isModalSearch?: boolean
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(searchDraftAgreementsRequest(isModalSearch));
        return SearchRequests.getDraftAgreements(draftAgreementsQuery, lookupValues)
            .then((result: IDraftAgreementSearchResult[]) => {
                dispatch(searchDraftAgreementsSuccess(result));
                return;
            }).catch(err => {
                dispatch(searchDraftAgreementsFailure(err));
            });
    };
};

export const searchDraftAgreementsIPThunk = (
    draftAgreementsIPQuery: IIPsSearchQuery,
    isModalSearch?: boolean
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(searchDraftAgreementsIPRequest(isModalSearch));
        return SearchRequests.getDraftAgreementsIp(draftAgreementsIPQuery)
            .then((result: IIPsSearchResult[]) => {
                if (result == null || result.length == 0) {
                    dispatch(searchDraftAgreementsIPSuccess([]));
                    return [];
                }
                dispatch(searchDraftAgreementsIPSuccess(result));
                return;
            }).catch(err => {
                dispatch(searchDraftAgreementsIPFailure(err));
            });
    };
};

export const searchDraftAgreementsWorksThunk = (
    draftAgreementsWorksQuery: IWorksSearchQuery,
    isModalSearch?: boolean
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(searchDraftAgreementsWorksRequest(isModalSearch));
        return SearchRequests.getDraftAgreementWorks(draftAgreementsWorksQuery)
            .then((result: IWorksSearchResult[]) => {
                if (result == null || result.length == 0) {
                    dispatch(searchDraftAgreementsWorksSuccess([]));
                    return [];
                }
                dispatch(searchDraftAgreementsWorksSuccess(result));
                return;
            }).catch(err => {
                dispatch(searchDraftAgreementsWorksFailure(err));
            });
    };
};

export const searchRegisteredAgreementsThunk = (
    registeredAgreementsQuery: IRegisteredAgreementSearchQuery,
    lookupValues: ILookupDictionary,
    isModalSearch?: boolean
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(searchRegisteredAgreementsRequest(isModalSearch));
        return SearchRequests.getRegisteredAgreements(registeredAgreementsQuery, lookupValues)
            .then((result: IRegisteredAgreementSearchResult[]) => {
                dispatch(searchRegisteredAgreementsSuccess(result));
                return;
            }).catch(err => {
                dispatch(searchRegisteredAgreementsFailure(err));
            });
    };
};

export const getDraftAgreementDetailsThunk = (
    dataSource: string,
    agreementId: number,
    lookupValues: ILookupDictionary,
    draftAgreementsMaintenanceDataViewData: IMembersPortalComponentDataItem,
    formats?: FormatFields[]
) => {
    return (dispatch: Dispatch) => {
        dispatch(getDraftAgreementDetailsRequest())
        dispatch(showLoading());
        return SearchRequests.getDraftAgreement(dataSource, agreementId)
            .then((res: IAgreement) => {
                dispatch(getDraftAgreementDetailsSuccess(res));
                const agreementWholeWorks = res.agreementWork;
                const agreementData: IApplicableWorkSearchQuery = {
                    agreementID: agreementId,
                    workNumber: "",
                    page: 1,
                    workName: "",
                    pageSize: 1000,
                    currentUserNameNumber: "",
                    dataSource: dataSource
                };
                return SearchRequests.getApplicableWorks(agreementData)
                    .then((works: IAgreementWork[]) => {
                        const updatedRes: IAgreement = {
                            ...res,
                            agreementWork: works,
                            agreementAllWork: agreementWholeWorks,
                        };

                        let newDraftAgreementTab: ITabReduxItem = {
                            title: AgreementDetailsMapper.getDraftAgreementTitle(updatedRes),
                            component: DRAFT_AGREEMENTS_MAINTENANCE_PAGE.component,
                            name: "draftAgreements",
                            agreementMaintenanceState: {
                                loaded: false,
                                agreement: AgreementDetailsMapper.mapAgreementToState(updatedRes),
                                agreementBatchOperationInProgress: false
                            },
                            changesMade: false,
                            validationMessages: undefined,
                            saveSuccessful: undefined,
                            postSuccessful: undefined,
                            formatFields: formats
                        };
                        dispatch(mp_addTab(newDraftAgreementTab, true));
                        dispatch(hideModal());
                    })
            })
            .catch(err => {
                dispatch(getDraftAgreementDetailsFailure(err, agreementId));
                dispatch(hideModal());
            });
    };
}

export const getRegisteredAgreementDetailsThunk = (
    dataSource: string,
    agreementId: number,
    lookupValues: ILookupDictionary,
    registeredAgreementsMaintenanceDataViewData: IMembersPortalComponentDataItem,
    formats?: FormatFields[]
) => { }


export const searchDraftWorksThunk = (
    draftWorkQuery: IDraftWorkSearchQuery,
    isModalSearch?: boolean,
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch, getState: () => IAppState) => {
        const lookupValues = getState().lookupEntities;
        dispatch(searchDraftWorksRequest(isModalSearch));

        // Get Index Work Details
        return SearchRequests.getDraftWorks(draftWorkQuery)
            .then((result: IDraftWorkSearchResult[]) => {
                let workResults = result.map((w) => ({
                    ...w,
                    status: searchLookupValueByCode(
                        WORK_STATUS_LOOKUP,
                        lookupValues,
                        w.status
                    ) ?? "-"
                }));
                if (!workResults || workResults.length === 0) {
                    dispatch(searchDraftWorksSuccess([]));
                    return [];
                }
                dispatch(searchDraftWorksSuccess(workResults));
            }).catch(err => {
                dispatch(searchDraftWorksFailure(err));
            });
    };
};

export const getDraftWorkDetailsThunk = (
    dataSource: string,
    workId: number,
    lookupValues: ILookupDictionary,
    draftWorkMaintenanceDataViewData: IMembersPortalComponentDataItem,
    formats?: FormatFields[]
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getDraftWorkDetailsRequest())
        dispatch(showLoading());
        return SearchRequests.getDraftWork(dataSource, workId)
            .then((res: IWork) => {
                dispatch(getDraftWorkDetailsSuccess(res));

                let newDraftWorkTab: ITabReduxItem = {
                    title: WorkDetailsMapper.getOriginalFullTitleFromWorkNames(res.workNames, workId),
                    component: DRAFT_WORKS_MAINTENANCE_PAGE.component,
                    name: "draftWorks",
                    draftWorkMaintenanceState: {
                        loaded: false,
                        work: WorkDetailsMapper.mapWorkToWorkState(res, lookupValues),
                    },
                    changesMade: false,
                    formatFields: formats
                };
                dispatch(mp_addTab(newDraftWorkTab, true));
                dispatch(hideModal());
            })
            .catch(err => {
                dispatch(getDraftWorkDetailsFailure(err, workId));
                dispatch(hideModal());
            });
    };
}

export const getDraftSetListDetailsThunk = (
    dataSource: string,
    productCoreId: number,
    lookupValues: ILookupDictionary,
    formats?: FormatFields[]
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getDraftSetListDetailsRequest())
        dispatch(showLoading());
        return SearchRequests.getGetProductDetails(dataSource, productCoreId)
            .then(async (res: IProductCore) => {
                if (res.productWorks && res.productWorks.length > 0) {
                    const productWorks: IProductWork[] = [];

                    const intrayWorkIDs: number[] = res.productWorks.filter(pw => pw.workDataSource == "Intray").map(pw => pw.workCode)
                    const repertoireWorkIDs: number[] = res.productWorks.filter(pw => pw.workDataSource == "Repertoire").map(pw => pw.workCode)
                    const totalWorkIDs = intrayWorkIDs.length + repertoireWorkIDs.length;

                    for (var retries = 0; retries < 5; retries++) {

                        var t = 500 * (2 ** retries);
                        await new Promise(resolve => setTimeout(resolve, t));

                        if (intrayWorkIDs.length > 0) {
                            let hydratedWorks = hydrateProductWorksFromIndex(intrayWorkIDs, 'Intray', res.productWorks);

                            (await hydratedWorks).forEach(w => {
                                productWorks.push(w)
                                var index = intrayWorkIDs.indexOf(w.workCode)
                                intrayWorkIDs.splice(index, 1)
                            })

                        }

                        if (repertoireWorkIDs.length > 0) {
                            let hydratedWorks = hydrateProductWorksFromIndex(repertoireWorkIDs, 'Repertoire', res.productWorks);
                            (await hydratedWorks).forEach(w => {
                                productWorks.push(w)
                                var index = repertoireWorkIDs.indexOf(w.workCode)
                                repertoireWorkIDs.splice(index, 1)
                            })
                        }

                        if (productWorks.length == totalWorkIDs) {
                            break;
                        }
                    }
                    res.productWorks = productWorks;
                }
                dispatch(getDraftSetListDetailsSuccess(res));

                let newDraftSetListTab: ITabReduxItem = {
                    title: ProductDetailsMapper.getOriginalTitleFromProductNames(res.productNames),
                    component: DRAFT_SET_LISTS_MAINTENANCE_PAGE.component,
                    name: "draftSetLists",
                    draftSetListsMaintenanceState: {
                        loaded: false,
                        setLists: ProductDetailsMapper.mapProductToState(res, formats),
                        dataSource: dataSource === DataSource.Intray ? DataSource.Intray : DataSource.Repertoire
                    },
                    changesMade: false,
                    formatFields: formats
                };
                dispatch(mp_addTab(newDraftSetListTab, true));
                dispatch(hideModal());
            })
            .catch(err => {
                dispatch(getDraftSetListDetailsFailure(err, productCoreId));
                dispatch(hideModal());
            });
    };
}

export const getSetListWorkDefaultDurationConfigThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getSetListWorkDefaultDurationConfigRequest());
        return SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_DEFAULT_DURATIONS_FOR_WORK_SOURCES, INGESTION_GROUP)
            .then((res) => {
                const productDefaultWorkDurations: Record<string, number> = Object.fromEntries(
                    res.map(item => [item.WorkSource, Number(item.DefaultDurationSecs)])
                );
                const setListWorkDefaultDuration = productDefaultWorkDurations[SET_LIST_TYPE];
                dispatch(getSetListWorkDefaultDurationConfigSuccess(setListWorkDefaultDuration));
            })
            .catch((error: any) => {
                dispatch(getSetListWorkDefaultDurationConfigFailure(error));;
            });
    }
}


export const saveDraftWorkThunk = (
    work: IWorkState,
    draftWorkMaintenancePageData: IMembersPortalComponentDataItem,
    lookupValues: ILookupDictionary
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(showLoading());
        dispatch(saveDraftWorkRequest());
        const draftWorkValidationMessages = MembersPortalWorkValidator.validateWork(work, draftWorkMaintenancePageData);

        if (draftWorkValidationMessages.length === 0) {
            return MembersPortalService.saveDraftWork(
                WorkDetailsMapper.mapWorkStateToWork(work, lookupValues, true)
            )
                .then((res: any) => {
                    if (res.status !== 200 || !res.data.success) {
                        const errorMessages: IValidationMessage[] =
                            res.data.messages || [GENERIC_ERROR];
                        const saveResult: IWorkSaveResult = {
                            messages: errorMessages,
                            work: res.data.work,
                            saved: false,
                            success: false,
                            validationSuccess: false
                        };
                        dispatch(saveDraftWorkFailure(saveResult, lookupValues));
                        return false;
                    }

                    else {
                        dispatch(saveDraftWorkSuccess(res.data, lookupValues));
                        return true;
                    }
                })
                .catch((error: any) => {
                    dispatch(saveDraftWorkFailure(error, lookupValues));
                    return false;
                })
                .finally(() => { dispatch(hideModal()); });
        }
        else {
            const result: IWorkSaveResult = {
                saved: false,
                success: false,
                validationSuccess: false,
                messages: MembersPortalWorkValidator.validateWork(work),
                work: WorkDetailsMapper.mapWorkStateToWork(work, lookupValues, true)
            };
            dispatch(saveDraftWorkFailure(result, lookupValues));
            dispatch(hideModal());
            return Promise.resolve(false);
        }
    };
};

export const saveDraftSetListThunk = (
    setList: IProductState,
    draftSetListsMaintenancePageData: IMembersPortalComponentDataItem,
    lookupValues: ILookupDictionary
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(showLoading())
        let draftSetListValidationMessages = MembersPortalSetListsValidator.validateSetLists(setList, draftSetListsMaintenancePageData);
        if (draftSetListValidationMessages.length === 0) {

            return MembersPortalService.saveDraftSetLists(ProductDetailsMapper.mapStateToProduct(setList, true))
                .then(async res => {
                    if (res.status !== 200 || !res.data.success) {
                        const errorMessages: IValidationMessage[] = res.data.messages || [GENERIC_ERROR];
                        const saveResult: IProductSaveResult = {
                            messages: errorMessages,
                            product: res.data.product,
                            saved: false,
                            success: false,
                            validationSuccess: false
                        }
                        dispatch(saveDraftSetListsFailure(saveResult));
                        dispatch(hideModal());
                    }
                    else {
                        if (res.data.product.productWorks && res.data.product.productWorks.length > 0) {
                            const productWorks: IProductWork[] = [];

                            const intrayWorkIDs: number[] = res.data.product.productWorks.filter(pw => pw.workDataSource == "Intray").map(pw => pw.workCode)
                            const repertoireWorkIDs: number[] = res.data.product.productWorks.filter(pw => pw.workDataSource == "Repertoire").map(pw => pw.workCode)
                            const totalWorkIDs = intrayWorkIDs.length + repertoireWorkIDs.length;

                            for (var retries = 0; retries < 5; retries++) {

                                var t = 500 * (2 ** retries);
                                await new Promise(resolve => setTimeout(resolve, t));

                                if (intrayWorkIDs.length > 0) {
                                    let hydratedWorks = hydrateProductWorksFromIndex(intrayWorkIDs, 'Intray', res.data.product.productWorks);
                                    (await hydratedWorks).forEach(w => {
                                        productWorks.push(w)
                                        var index = intrayWorkIDs.indexOf(w.workCode)
                                        intrayWorkIDs.splice(index, 1)
                                    })

                                }

                                if (repertoireWorkIDs.length > 0) {
                                    let hydratedWorks = hydrateProductWorksFromIndex(repertoireWorkIDs, 'Repertoire', res.data.product.productWorks);
                                    (await hydratedWorks).forEach(w => {
                                        productWorks.push(w)
                                        var index = repertoireWorkIDs.indexOf(w.workCode)
                                        repertoireWorkIDs.splice(index, 1)
                                    })
                                }

                                if (productWorks.length == totalWorkIDs) {
                                    break;
                                }
                            }
                            res.data.product.productWorks = productWorks;

                        }
                        dispatch(saveDraftSetListSuccess(res.data));
                        dispatch(hideModal());
                    }
                })
                .catch(err => {
                    dispatch(hideModal());
                    dispatch(saveDraftSetListsFailure(err));
                })
                .finally(() => hideModal())
        }
        else {
            const result: IProductSaveResult = {
                saved: false,
                success: false,
                validationSuccess: false,
                messages: draftSetListValidationMessages,
                product: ProductDetailsMapper.mapStateToProduct(setList, true)
            }
            dispatch(saveDraftSetListsFailure(result));
            dispatch(hideModal());
        }
    }
}

export const saveDraftAgreementThunk = (
    agreement: IAgreementState,
    draftAgreementMaintenanceGeneralDataViewData: IMembersPortalComponentDataItem,
    lookupValues: ILookupDictionary,
    postAgreement: boolean,
    currentUserNumber: string,
    defaultTerritories?: any,
    resetChangesMade?: boolean
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(showLoading())
        let draftAgreementValidationMessages = [];
        SearchRequests.getConfigurationParameter(
            CONFIGURATION_PARAMETER_SUBMITTER_MUST_BE_ASSOCIATED_FIELDS_KEY,
            AGREEMENT_MAINTENANCE_GROUP
        )
            .then((formats) => {
                if (!formats) {
                    draftAgreementValidationMessages = MembersPortalAgreementValidator.validateAgreement(
                        agreement,
                        currentUserNumber,
                        draftAgreementMaintenanceGeneralDataViewData
                    );
                }
            })

        if (draftAgreementValidationMessages.length === 0) {


            return MembersPortalService.saveDraftAgreement(AgreementDetailsMapper.mapMembersStateToAgreement(agreement, lookupValues, defaultTerritories), postAgreement)
                .then(async res => {
                    if (res.status !== 200 || !res.data.success) {
                        const errorMessages: IValidationMessage[] = res.data.messages || [GENERIC_ERROR];
                        const saveResult: IAgreementSaveResult = {
                            messages: errorMessages,
                            agreement: res.data.agreement,
                            saved: false,
                            success: false,
                            validationSuccess: false
                        }
                        dispatch(saveDraftAgreementFailure(saveResult));
                        dispatch(hideModal());
                    }
                    else {
                        dispatch(saveDraftAgreementSuccess(res.data, resetChangesMade));
                        dispatch(hideModal());
                    }

                })
                .catch(err => {
                    dispatch(hideModal());
                    dispatch(saveDraftAgreementFailure(err));
                })
                .finally(() => hideModal())
        }
        else {
            const result: IAgreementSaveResult = {
                saved: false,
                success: false,
                validationSuccess: false,
                messages: MembersPortalAgreementValidator.validateAgreement(agreement, currentUserNumber),
                agreement: AgreementDetailsMapper.mapStateToAgreement(agreement)
            }
            dispatch(saveDraftAgreementFailure(result));
            dispatch(hideModal());
        }
    }
}

export const saveDraftLivePerformanceThunk = (
    usage: IUsageGroupState,
    livePerformanceMaintenanceGeneralDataViewData: IMembersPortalComponentDataItem
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch, getState: () => IAppState) => {
        dispatch(showLoading())
        let draftLivePerformanceValidationMessages = MembersPortalLivePerformanceValidator.validateLivePerformance(usage, livePerformanceMaintenanceGeneralDataViewData);
        if (draftLivePerformanceValidationMessages.length === 0) {
            const state = getState();
            const customerName = state.account.customer;
            usage.usages.forEach((item, index) => {
                if (index > 0 && !usage.moreDates.some(d => item?.guid?.value == d?.id)) {
                    item.isDeleted = true;
                }
            });

            usage.customerVenues = [{
                name: customerName,
                code: "",
                customerID: 0
            }];

            if (usage.venueDetails) {
                usage.venueDetails.venueLookupType = usage.venueDetails.venueLookupType ? usage.venueDetails.venueLookupType.toString() : "";
                usage.venueDetails.venueType = usage.venueDetails.venueType ? usage.venueDetails.venueType.toString() : "";
            }

            if ((!usage.matchingProducts || usage.matchingProducts.length === 0) && usage.livePerformanceSetList) {
                const setList = usage.livePerformanceSetList;
                usage.matchingProducts = [
                    {
                        status: setList.productStatus,
                        matchType: DEFINITE_MATCH,
                        type: setList.type,
                        id1: setList.id1,
                        id2: setList.id2,
                        title: setList.title,
                        source: setList.source,
                        artist: setList.artist,
                        contributor: setList.contributor,
                        number: setList.number ?? [],
                        productCoreID: setList.productCoreID
                    }
                ];
            }

            return MembersPortalService.saveDraftLivePerformance(UsageDetailsMapper.mapStateUsageGroup(usage, true))
                .then(async res => {
                    if (res.status !== 200 || !res.data.success) {
                        let errorMessages = res.data.messages || [GENERIC_ERROR];
                        const saveResult: IUsageSaveResult = {
                            messages: errorMessages,
                            usageGroup: res.data.usageGroup,
                            saved: false,
                            success: false,
                            validationSuccess: false,
                            isReadonly: false,
                        }
                        dispatch(saveDraftLivePerformanceFailure(saveResult));
                        return;
                    }
                    const saveResultOk: IUsageSaveResult = {
                        messages: res.data.message,
                        usageGroup: res.data.usageGroup,
                        saved: true,
                        success: true,
                        validationSuccess: true,
                        isReadonly: true,
                    }
                    dispatch(saveDraftLivePerformanceSuccess(saveResultOk));
                })
                .catch(err => {
                    dispatch(saveDraftLivePerformanceFailure(err));
                })
                .finally(() => dispatch(hideModal()));
        }
        else {
            const saveResult: IUsageSaveResult = {
                messages: draftLivePerformanceValidationMessages,
                usageGroup: UsageDetailsMapper.mapStateUsageGroup(usage, true),
                saved: false,
                success: false,
                validationSuccess: false,
                isReadonly: false,
            }
            dispatch(saveDraftLivePerformanceFailure(saveResult));
            dispatch(hideModal());
        }

    }
}

export const saveContributorCommentThunk = (
    contributorID: number,
    comments: string
): ThunkAction<void, IAppState, null, Action<string>> => {

    return (dispatch: Dispatch) => {
        dispatch(saveContributorComment(contributorID, comments));
        dispatch(hideModal());
    }

}

export const searchRegisteredWorksThunk = (
    registeredWorkQuery: IRegisteredWorkSearchQuery,
    isModalSearch?: boolean,
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch, getState: () => IAppState) => {
        const lookupValues = getState().lookupEntities;
        dispatch(searchRegisteredWorksRequest(isModalSearch));

        // Get Index Work Details
        return SearchRequests.getRegisteredWorks(registeredWorkQuery)
            .then((result: IRegisteredWorkSearchResult[]) => {
                let workResults = result.map((w) => ({
                    ...w,
                    status: searchLookupValueByCode(
                        WORK_STATUS_LOOKUP,
                        lookupValues,
                        w.status
                    ) ?? "-"
                }));

                if (!workResults || workResults.length === 0) {
                    dispatch(searchRegisteredWorksSuccess([]));
                    return [];
                }
                dispatch(searchRegisteredWorksSuccess(workResults));
            }).catch(err => {
                dispatch(searchRegisteredWorksFailure(err));
            });
    };
};

export const getCueSheetsDetailsThunk = (
    dataSource: string,
    productCoreId: number,
    lookupValues: ILookupDictionary,
    formats?: FormatFields[]
): ThunkAction<void, IAppState, null, Action<string>> => {
    return async (dispatch: Dispatch) => {
        dispatch(getCueSheetsDetailsRequest());
        dispatch(showLoading());

        try {
            const product = await SearchRequests.getGetProductDetails(dataSource, productCoreId);

            if (product.productWorks?.length > 0) {
                const hydratedWorks = await hydrateAllProductWorks(product.productWorks);

                if (hydratedWorks.length && 'order' in hydratedWorks[0]) {
                    hydratedWorks.sort((a, b) =>
                        (a?.order ?? Infinity) - (b?.order ?? Infinity)
                    );
                }

                product.productWorks = hydratedWorks;
            }

            dispatch(getCueSheetsDetailsSuccess(product));

            const cueSheetDetailsTab: ITabReduxItem = {
                title: ProductDetailsMapper.getOriginalTitleFromProductNames(product.productNames),
                component: CUE_SHEETS_MAINTENANCE_PAGE.component,
                name: "membersPortalMyDraftCueSheets",
                cueSheetMaintenanceState: {
                    loaded: false,
                    cueSheets: ProductDetailsMapper.mapProductToState(product, formats),
                    dataSource: dataSource === DataSource.Intray ? DataSource.Intray : DataSource.Repertoire
                },
                changesMade: false,
                formatFields: formats
            };

            dispatch(mp_addTab(cueSheetDetailsTab, true));
            dispatch(hideModal());
        } catch (err) {
            dispatch(getCueSheetsDetailsFailure(err, productCoreId));
        }
    };
};

//TODO: this function can be used by getDraftSetListDetailsThunk
async function hydrateAllProductWorks(allWorks: IProductWork[]): Promise<IProductWork[]> {
    const intrayIDs = allWorks.filter(w => w.workDataSource === DataSource.Intray).map(w => w.workCode);
    const repertoireIDs = allWorks.filter(w => w.workDataSource === DataSource.Repertoire).map(w => w.workCode);
    const totalExpected = intrayIDs.length + repertoireIDs.length;

    const hydratedWorks: IProductWork[] = [];

    for (let retry = 0; retry < 5; retry++) {
        const delay = 500 * (2 ** retry);
        await new Promise(res => setTimeout(res, delay));

        await hydrateChunk(DataSource.Intray, intrayIDs, allWorks, hydratedWorks);
        await hydrateChunk(DataSource.Repertoire, repertoireIDs, allWorks, hydratedWorks);

        if (hydratedWorks.length === totalExpected) break;
    }

    return hydratedWorks;
}

async function hydrateChunk(
    source: DataSource.Intray | DataSource.Repertoire,
    ids: number[],
    allWorks: IProductWork[],
    output: IProductWork[]
): Promise<void> {
    if (ids.length === 0) return;

    const hydrated = await hydrateProductWorksFromIndex(ids, source, allWorks);

    hydrated.forEach(w => {
        output.push(w);
        const index = ids.indexOf(w.workCode);
        if (index > -1) ids.splice(index, 1);
    });
}

export const searchCueSheetsThunk = (
    cueSheetQuery: ICueSheetsSearchQuery,
    getAllCueSheets: boolean,
    searchMethod: string
): ThunkAction<void, IAppState, null, Action<string>> => {
    return async (dispatch: Dispatch) => {
        dispatch(searchCueSheetsRequest());

        try {
            const result = await SearchRequests.getCueSheets(cueSheetQuery, getAllCueSheets, searchMethod);
            dispatch(searchCueSheetsSuccess(result ?? []));
        } catch (err: unknown) {
            const errorMessage = err instanceof Error ? err.message : String(err);
            dispatch(searchCueSheetsFailure(errorMessage));
        }
    };
};

export const searchRegisteredSetListsThunk = (
    setListQuery: IRegisteredSetListsSearchQuery,
    searchMethod: string
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(searchRegisteredSetListsRequest());

        return SearchRequests.getSetLists(setListQuery, searchMethod)
            .then((result: IRegisteredSetListsSearchResults[]) => {
                if (result == null || result.length == 0) {
                    dispatch(searchRegisteredSetListsSuccess([]));
                } else {
                    dispatch(searchRegisteredSetListsSuccess(result));
                }
            }).catch(err => {
                dispatch(searchRegisteredSetListsFailure(err));
            });
    };
};


export const searchAllRegisteredWorksThunk = (
    allRegisteredWorkQuery: IAllRegisteredWorkSearchQuery,
    isModalSearch?: boolean,
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch, getState: () => IAppState) => {
        const lookupValues = getState().lookupEntities;
        dispatch(searchAllRegisteredWorksRequest(isModalSearch));

        // Get Index Work Details
        return SearchRequests.getAllRegisteredWorks(allRegisteredWorkQuery)
            .then((result: IAllRegisteredWorkSearchResult[]) => {
                let workResults = result.map((w) => ({
                    ...w,
                    status: searchLookupValueByCode(
                        WORK_STATUS_LOOKUP,
                        lookupValues,
                        w.status
                    ) ?? "-"
                }));

                if (!workResults || workResults.length === 0) {
                    dispatch(searchAllRegisteredWorksSuccess([]));
                    return [];
                }
                dispatch(searchAllRegisteredWorksSuccess(workResults));
            }).catch(err => {
                dispatch(searchAllRegisteredWorksFailure(err));
            });
    };
};

export const getRegisteredWorkDetailsThunk = (
    dataSource: string,
    workId: number,
    lookupValues: ILookupDictionary,
    registeredWorkMaintenanceDataViewData: IMembersPortalComponentDataItem,
    formats?: FormatFields[],
    includeAllMyAccounts?: boolean
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getRegisteredWorkDetailsRequest());
        dispatch(showLoading());
        return SearchRequests.getRegisteredWork(dataSource, workId, includeAllMyAccounts)
            .then((res: IWork) => {
                dispatch(getRegisteredWorkDetailsSuccess(res));

                let newRegisteredWorkTab: ITabReduxItem = {
                    title: WorkDetailsMapper.getOriginalFullTitleFromWorkNames(res.workNames, workId),
                    component: REGISTERED_WORKS_VIEW_PAGE.component,
                    name: "myRegisteredWorks",
                    registeredWorkMaintenanceState: {
                        loaded: false,
                        work: WorkDetailsMapper.mapWorkToWorkState(res, lookupValues),
                    },
                    changesMade: false,
                    formatFields: formats
                };
                dispatch(mp_addTab(newRegisteredWorkTab));
                dispatch(hideModal());
            })
            .catch(err => {
                dispatch(getRegisteredWorkDetailsFailure(err, workId));
                dispatch(hideModal());
            });
    };
}

export const getAllRegisteredWorkDetailsThunk = (
    dataSource: string,
    workId: number,
    lookupValues: ILookupDictionary,
    registeredWorkMaintenanceDataViewData: IMembersPortalComponentDataItem,
    formats?: FormatFields[]

): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getAllRegisteredWorkDetailsRequest())
        dispatch(showLoading());
        return SearchRequests.getRegisteredWork(dataSource, workId, true)
            .then((res: IWork) => {
                dispatch(getAllRegisteredWorkDetailsSuccess(res));

                let newRegisteredWorkTab: ITabReduxItem = {
                    title: WorkDetailsMapper.getOriginalFullTitleFromWorkNames(res.workNames, workId),
                    component: REGISTERED_WORKS_VIEW_PAGE.component,
                    name: "allRegisteredWorks",
                    registeredWorkMaintenanceState: {
                        loaded: false,
                        work: WorkDetailsMapper.mapWorkToWorkState(res, lookupValues),
                    },
                    changesMade: false,
                    formatFields: formats
                };
                dispatch(mp_addTab(newRegisteredWorkTab));
                dispatch(hideModal());
            })
            .catch(err => {
                dispatch(getAllRegisteredWorkDetailsFailure(err, workId));
                dispatch(hideModal());
            });
    };
}


export const saveRegisteredWorkThunk = (
    work: IWorkState,
    registeredWorkMaintenancePageData: IMembersPortalComponentDataItem,
    lookupValues: ILookupDictionary
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(showLoading())
        dispatch(saveRegisteredWorkRequest())
        let registeredWorkValidationMessages = MembersPortalWorkValidator.validateWork(work, registeredWorkMaintenancePageData);

        if (registeredWorkValidationMessages.length === 0) {
            return MembersPortalService.saveRegisteredWork(WorkDetailsMapper.mapWorkStateToWork(work, lookupValues, true))
                .then((res) => {
                    if (res.status !== 200 || !res.data.success) {
                        const errorMessages: IValidationMessage[] = res.data.messages || [GENERIC_ERROR];
                        const saveResult: IWorkSaveResult = {
                            messages: errorMessages,
                            work: res.data.work,
                            saved: false,
                            success: false,
                            validationSuccess: false
                        }
                        dispatch(saveRegisteredWorkFailure(saveResult, lookupValues));
                        dispatch(hideModal());
                    }
                    dispatch(saveRegisteredWorkSuccess(res.data, lookupValues));
                    dispatch(hideModal());
                })
                .catch(err => {
                    dispatch(hideModal());
                    dispatch(saveRegisteredWorkFailure(err, lookupValues));
                })
        }
        else {
            const result: IWorkSaveResult = {
                saved: false,
                success: false,
                validationSuccess: false,
                messages: MembersPortalWorkValidator.validateWork(work),
                work: WorkDetailsMapper.mapWorkStateToWork(work, lookupValues, true)
            }
            dispatch(saveRegisteredWorkFailure(result, lookupValues));
            dispatch(hideModal());
        }
    }
}

export const getUploadCueSheetsFilesThunk = (currentUserNameNumber: string): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        if (!currentUserNameNumber) return;
        dispatch(getUploadCueSheetsFilesRequest());
        Promise.all([
            SearchRequests.getCueSheetsBlobs(`repertoire/portalcues/input`, currentUserNameNumber),
            SearchRequests.getCueSheetsBlobs(`repertoire/portalcues/error`, currentUserNameNumber),
            SearchRequests.getCueSheetsBlobs(`repertoire/portalcues/archive`, currentUserNameNumber)
        ]).then(([inputFiles, errorFiles, archiveFiles]) => {
            dispatch(uploadCueSheetsFiles(
                inputFiles,
                errorFiles,
                archiveFiles,
                null,
                currentUserNameNumber
            ));
        });
    }
}

export const loadMembersPortalFromPathThunk = (pathInfo: IMembersPortalPathInfo, currentUserNameNumber: string, location: Location, tabs?: ITabReduxItem[], lookups?: ILookupDictionary): ThunkAction<
    void,
    IAppState,
    null,
    Action<string>> => {
    return (dispatch: Dispatch) => {
        if (!pathInfo || !pathInfo.submodule)
            return null;
        const { submodule } = pathInfo;

        switch (submodule) {
            case 'draftWorks':
                dispatch(mp_addTab(DRAFT_WORKS_PAGE));
                break;
            case 'myRegisteredWorks':
                dispatch(mp_addTab(REGISTERED_WORKS_PAGE));
                break;
            case 'allRegisteredWorks':
                dispatch(mp_addTab(ALL_REGISTERED_WORKS_PAGE));
                break;
            case 'statements':
                dispatch(mp_addTab(MEMBER_STATEMENTS_PAGE));
                break;
            case 'draftSetLists':
                dispatch(mp_addTab(DRAFT_SET_LISTS_PAGE));
                break;
            case 'registeredSetLists':
                dispatch(mp_addTab(REGISTERED_SET_LISTS_PAGE));
                break;
            case 'myPackages':
                dispatch(mp_addTab(MY_PACKAGES_PAGE))
                break;
            case 'livePerformanceSubmission':
                dispatch(mp_addTab(LIVE_PERFORMANCE_SUBMISSION_PAGE));
                break;
            case 'unpaidClaimsMembers':
                dispatch(mp_addTab(UNPAID_CLAIMS_PAGE));
                break;
            case 'draftAgreements':
            case 'agreements':
                dispatch(mp_addTab(DRAFT_AGREEMENTS_PAGE));
                break;
            case 'myRegisteredAgreement':
                dispatch(mp_addTab(REGISTERED_AGREEMENTS_PAGE));
                break;
            case 'submitNewLivePerformance':
                let newPerfTab = tabs && tabs.findIndex(x => x.title === 'Submit New Live Performance')
                if (newPerfTab >= 0)
                    dispatch(mp_openTab(newPerfTab))
                else {
                    SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, WORK_MAINTENANCE_GROUP)
                        .then(formats => {
                            const distribution = SearchRequests.getLivePerformancesDistribution()
                                .then(distribution => {
                                    dispatch(createNewDraftLivePerformance(lookups, true, null, formats, distribution ? distribution.distributionCode : "", currentUserNameNumber));
                                });
                        });
                }
                break;
            case 'registerNewAgreement':
                dispatch(createNewDraftAgreement(lookups, currentUserNameNumber, true, null))
                break;
            case 'registerNewWork':
                dispatch<any>(addNewDraftWorkThunk(lookups, currentUserNameNumber, true, null))
                break;
            case 'registerNewSetLists':
                let newSetListTab = tabs && tabs.findIndex(x => x.title === 'New Draft Set Lists')
                if (newSetListTab >= 0)
                    dispatch(mp_openTab(newSetListTab))
                else
                    dispatch(createNewDraftSetLists(lookups, currentUserNameNumber, true, null));
                break;

            case 'uploadCueSheets':
                if (!currentUserNameNumber) return;
                dispatch<any>(getUploadCueSheetsFilesThunk(currentUserNameNumber));
                break;

            case 'claimsHistory':
                dispatch(mp_addTab(CLAIMS_HISTORY_PAGE));
                break;
            case 'myRegisteredCueSheets':
                dispatch(mp_addTab(MY_REGISTERED_CUE_SHEET_PAGE));
                break;
            case 'allRegisteredCueSheets':
                dispatch(mp_addTab(ALL_REGISTERED_CUE_SHEET_PAGE));
                break;
            case 'myDraftCueSheets':
                dispatch(mp_addTab(MY_DRAFT_CUE_SHEET_PAGE));
                break;
            case 'membersPortalMyRegisteredCueSheets':
                dispatch(mp_addTab(MY_REGISTERED_CUE_SHEET_PAGE));
                break;
            case 'membersPortalAllRegisteredCueSheets':
                dispatch(mp_addTab(ALL_REGISTERED_CUE_SHEET_PAGE));
                break;
            case 'membersPortalMyDraftCueSheets':
                dispatch(mp_addTab(MY_DRAFT_CUE_SHEET_PAGE))
                break;
        }
    }
};

export const addNewDraftWorkThunk = (
    lookups: ILookupDictionary,
    currentUserNameNumber?: string,
    isNew: boolean = true,
    dataView?: IMembersPortalComponentDataItem
) => (dispatch: any) => {
    return SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, WORK_MAINTENANCE_GROUP)
        .then((formats) => {
            dispatch(createNewDraftWork(lookups, currentUserNameNumber, isNew, dataView, formats || []));
        });
};

export const deleteDraftWorkThunk = (
    dataSource: string,
    workId: number,
    activeTab: number,
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(deleteDraftWorkRequest());
        dispatch(showLoading());
        return MembersPortalService.deleteWork(workId)
            .then(result => {
                dispatch(deleteDraftWorkSuccess(result.data));
            })
            .finally(() => {
                dispatch(mp_removeTab(activeTab));
                dispatch(hideModal());
            })
            .catch(err => {
                dispatch(deleteDraftWorkFailure(err));
                dispatch(hideModal());
            });
    }
};

export const deleteDraftSetListThunk = (
    dataSource: string,
    setListId: number,
    activeTab: number,
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(deleteDraftSetListRequest());
        dispatch(showLoading());
        return MembersPortalService.deleteSetList(setListId)
            .then(result => {
                dispatch(deleteDraftSetListSuccess(result.data));
            })
            .finally(() => {
                dispatch(mp_removeTab(activeTab));
                dispatch(hideModal());
            })
            .catch(err => {
                dispatch(deleteDraftSetListFailure(err));
                dispatch(hideModal());
            });
    }
};

export const searchContributorsThunk = (
    searchBody: IContributorSearchQuery
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        searchBody.isMembersPortal = true;
        dispatch(searchContributorsRequest());
        return RepertoireSearchRequests.getContributors(searchBody)
            .then((res: IContributorSearchResult[]) => {
                let result = res.filter(x => x.type !== 'PG')
                dispatch(searchContributorsSuccess(result));
            })
            .catch(err => {
                dispatch(searchContributorsFailure(err));
            });
    };
};

export const getFullCataloguePackagePendingThunk = (
    userName: string
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {

        return RepertoireSearchRequests.GetAllPackages(userName)
            .then((res) => {
                dispatch(getFullCataloguePackagePendingSuccess(res.data));
            })
            .catch((err) => {
                dispatch(getFullCataloguePackagePendingFailure(err, userName));
            });
    };
};

export const CreatePackageFromCriteriaThunk = (
    userName: string,
    criteria: IRegisteredWorkSearchQuery
): ThunkAction<Promise<IAddtoPackageResult>, IAppState, null, Action<string>> => {
    return async (dispatch: Dispatch): Promise<IAddtoPackageResult> => {
        try {
            const res = await MembersPortalService.createPackageFromCriteria(userName, criteria);

            if (res?.status !== 200 || !res?.data?.success) {
                const errorMessages: IValidationMessage[] =
                    res?.data?.messages || [{ messageKey: GENERIC_ERROR }];

                const failResult: IAddtoPackageResult = {
                    messages: errorMessages,
                    saved: false,
                    success: false,
                    validationSuccess: false,
                };

                dispatch(createPackageFromCriteriaFailure(failResult));
                return failResult;
            }

            const successResult: IAddtoPackageResult = {
                success: true,
                saved: true,
                messages: res?.data?.messages || [],
                validationSuccess: true,
                MyPackages: res.data.myPackages,
            };

            dispatch(createPackageFromCriteriaSuccess(successResult));
            return successResult;
        } catch {
            const failResult: IAddtoPackageResult = {
                messages: [{ messageKey: GENERIC_ERROR }],
                saved: false,
                success: false,
                validationSuccess: false,
            };

            dispatch(createPackageFromCriteriaFailure(failResult));
            return failResult;
        }
    };
};

export const CreateCueSheetPackageFromCriteriaThunk = (
    userName: string,
    _criteria: ICueSheetsSearchQuery,
    isSearchAllMyAccounts: boolean
): ThunkAction<
    Promise<IAddtoPackageResult>,
    IAppState,
    null,
    Action<string>
> => {
    return async (dispatch: Dispatch, getState: () => IAppState): Promise<IAddtoPackageResult> => {
        if (getState().membersPortal.packageOperationInProgress) {
            return {
                messages: [{
                    messageKey: "packageOperationInProgressMessage"
                }],
                saved: false,
                success: false,
                validationSuccess: false,
            };
        }

        dispatch(createPackageFromCriteriaRequest());

        try {
            const response =
                await MembersPortalService.createCueSheetPackageFromCriteria(userName, isSearchAllMyAccounts);

            if (response?.status !== 200 || !response?.data?.success) {
                const failure: IAddtoPackageResult = {
                    messages: response?.data?.messages ?? [{ messageKey: GENERIC_ERROR }],
                    saved: false,
                    success: false,
                    validationSuccess: false,
                };

                dispatch(createPackageFromCriteriaFailure(failure));
                return failure;
            }

            const success: IAddtoPackageResult = {
                success: true,
                saved: true,
                validationSuccess: true,
                messages: response.data.messages ?? [],
                MyPackages: response.data.myPackages,
            };

            dispatch(createPackageFromCriteriaSuccess(success));
            return success;
        } catch (error: any) {
            const messageKey =
                error?.response?.status === 403
                    ? "productPackagePermissionFailureMessage"
                    : GENERIC_ERROR;

            const failure: IAddtoPackageResult = {
                messages: [{ messageKey }],
                saved: false,
                success: false,
                validationSuccess: false,
            };

            dispatch(createPackageFromCriteriaFailure(failure));
            return failure;
        }
    };
};

export const getWorkContributorDefaultLegalEntityValueConfigThunk = (): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getWorkContributorDefaultLegalEntityValueRequest());
        return SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_DEFAULT_SEARCH_VALUES, PORTAL_CONFIGURATION_GROUP)
            .then((res) => {
                dispatch(getWorkContributorDefaultLegalEntityValueSuccess(res.DefaultLegalEntityValue));
            })
            .catch((error: any) => {
                dispatch(getWorkContributorDefaultLegalEntityValueFailure(error));;
            });
    }
}

export const getShareSetsShownInPortalThunk = (): ThunkAction<
    void,
    IAppState,
    null,
    Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getShareSetsShownInPortalRequest());
        return SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_SHARE_SETS_SHOWNS_IN_PORTAL, PORTAL_CONFIGURATION_GROUP)
            .then((res: IPortalShareSetConfiguration[]) => {
                dispatch(getShareSetsShownInPortalSuccess(res));
            })
            .catch((error: any) => {
                dispatch(getShareSetsShownInPortalFailure(error));
            });
    }
}

export const getDefaultSetTypeGroupThunk = (): ThunkAction<
    void,
    IAppState,
    null,
    Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getDefaultSetTypeGroupRequest());
        return SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_DEFAULT_SET_TYPE_GROUP, PORTAL_CONFIGURATION_GROUP)
            .then((res: string) => {
                dispatch(getDefaultSetTypeGroupSuccess(res));
            })
            .catch((error: any) => {
                dispatch(getDefaultSetTypeGroupFailure(error));
            });
    }
}

export const updateWorkContributorIPThunk = (
    dataSource: DataSource,
    workContributor: IContributorItem, ip: IP
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(updateWorkContributorIPRequest());
        RepertoireService.linkedAgreements({
            dataSource: dataSource,
            ipBaseNumber: ip.ipBaseNumber,
            setTypeGroup: workContributor.setTypeGroup,
            setType: workContributor.setType
        })
            .then(res => {
                dispatch(updateWorkContributorIPSuccess(workContributor.workContributorID, ip, res.data));
            })
            .catch((error: any) => {
                dispatch(updateWorkContributorIPFailure());
            });
    };
};

export const searchArtistsThunk = (
    artist: IArtistSearchQuery,
    dataSource: string,
    keepModalOpenAfterSearch?: boolean
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(searchArtistsRequest());
        if (!keepModalOpenAfterSearch)
            dispatch(showLoading());
        return SearchRequests.getArtists(artist, dataSource)
            .then((res: IArtist[]) => {
                dispatch(searchArtistsSuccess(res));
                if (!keepModalOpenAfterSearch)
                    dispatch(hideModal());
            })
            .catch(err => {
                dispatch(searchArtistsFailure(err));
                if (!keepModalOpenAfterSearch)
                    dispatch(hideModal());
            });
    };
};

export const deleteRegisteredWorkThunk = (
    dataSource: string,
    workId: number,
    activeTab: number,
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(deleteRegisteredWorkRequest());
        dispatch(showLoading());
        return MembersPortalService.deleteWork(workId)
            .then(result => {
                dispatch(deleteRegisteredWorkSuccess(result.data));
            })
            .finally(() => {
                dispatch(mp_removeTab(activeTab));
                dispatch(hideModal());
            })
            .catch(err => {
                dispatch(deleteRegisteredWorkFailure(err));
                dispatch(hideModal());
            });
    }
};

export const removeWorkAttachmentIfExistsThunk = (attachedFile: IAttachedFile, source: DataSource, tabId?: string): ThunkAction<
    void,
    IAppState,
    null,
    Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(removeWorkAttachmentRequest());
        const model: IAddWorkAttachmentModel = {
            attachedFile: attachedFile,
            dataSource: source
        }
        return MembersPortalService.removeWorkAttachment(model)
            .then((res: boolean) => {
                if (res) {
                    dispatch(removeWorkAttachmentSuccess(model.attachedFile, tabId));
                }
            })
            .catch((error: any) => {
                dispatch(removeWorkAttachmentFailure(error));
            });
    }
}


export const searchRequestAccessIPThunk = (
    searchBody: IContributorSearchQuery
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(searchRequestAccessIPRequest());
        dispatch(showLoading());

        return RepertoireSearchRequests.getContributors(searchBody)
            .then((res: IContributorSearchResult[]) => {
                dispatch(searchRequestAccessIPRequestSuccess(res));
                dispatch(hideModal());
            })
            .catch(err => {
                dispatch(searchRequestAccessIPRequestFailure(err));
                dispatch(hideModal());
            });
    };
};

export const requestViewAsAccessThunk = (
    requestAccess: IContributorItem,
    userName: string
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(requestViewAsAccess());
        dispatch(showLoading());

        const model: IRequestViewAsAccessModel = {
            ipBaseNumber: requestAccess.ipBaseNumber,
            accountNumber: requestAccess.accountNumber as unknown as string,
            userName,
        };

        return AccountService.requestViewAsAccess(model)
            .then((res: boolean) => {
                dispatch(requestViewAsAccessSuccess(res));
                dispatch(hideModal());
            })
            .catch(err => {
                dispatch(requestViewAsAccessFailure(err));
                dispatch(hideModal());
            });
    };
};

export const getViewAsAccessRequestsThunk = (
    userName: string,
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch, getState) => {
        dispatch(getViewAsAccessRequests());
        dispatch(showLoading());

        return AccountService.getViewAsAccessRequests(userName)
            .then((res: IViewAsAccessRequest[]) => {
                dispatch(getViewAsAccessRequestsSuccess(res));

                const state = getState();
                const {
                    currentUserNameNumber,
                    currentUserIpBaseNumber,
                    currentUserAccountNumber,
                    currentViewAsUserName,
                    currentUserGuid,
                } = state.account;

                const hasValidMemberIdentity = hasAnyValidValue(currentUserNameNumber, currentUserAccountNumber);

                let hasCompleteActiveContext = hasValidMemberIdentity && !!currentViewAsUserName && !!currentUserGuid;


                if (hasCompleteActiveContext && res.length > 0) {
                    const activeContext = res.find(
                        (x) => x.accountId == currentUserGuid);
                    if (!activeContext || activeContext.status !== "Approved") {
                        hasCompleteActiveContext = false;
                        dispatch(
                            setCurrentUserNameNumber({
                                ipNameNumber: DEFAULT_IP_NAME_NUMBER,
                                ipBaseNumber: DEFAULT_IP_BASE_NUMBER,
                                accountNumber: DEFAULT_ACCOUNT_NUMBER,
                                userName: "",
                                guid: DEFAULT_GUID,
                            }),
                        );
                    }
                }

                if (!hasCompleteActiveContext && res && res.length > 0) {
                    const defaultApprovedAccount = res.find(
                        (x) => x.viewAs === true && x.status === "Approved",
                    );

                    const hasValidDefaultIdentity = hasAnyValidValue(
                        defaultApprovedAccount?.ipiNumber,
                        defaultApprovedAccount?.accountNumber,
                    );

                    if (
                        hasValidDefaultIdentity &&
                        defaultApprovedAccount?.ipName &&
                        defaultApprovedAccount?.accountId
                    ) {
                        dispatch(
                            setCurrentUserNameNumber({
                                ipNameNumber: defaultApprovedAccount.ipiNumber,
                                ipBaseNumber: DEFAULT_IP_BASE_NUMBER,
                                accountNumber: defaultApprovedAccount.accountNumber,
                                userName: defaultApprovedAccount.ipName,
                                guid: defaultApprovedAccount.accountId,
                            }),
                        );
                        dispatch<any>(getUserCRMValuesThunk());
                    }
                }

                dispatch(hideModal());
            })
            .catch((err) => {
                dispatch(getViewAsAccessRequestsFailure(err));
                dispatch(hideModal());
            });
    };
};


export const saveViewAsAccessThunk = (
    viewAsAccounts: IViewAsAccessRequest[],
    userName: string,
    portalType: string
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(saveViewAsAccess());
        dispatch(showLoading());

        const defaultAccount = viewAsAccounts.find(x => x.defaultAccess === true && x.status === "Approved");
        const viewAsAccount = viewAsAccounts.find(x => x.viewAs === true && x.status === "Approved");

        return AccountService.setViewAsDefaultAccount(defaultAccount?.accountNumber, viewAsAccount?.accountNumber, userName)
            .then((res: boolean) => {
                dispatch(saveViewAsAccessSuccess(viewAsAccounts, res));

                if (!res) {
                    dispatch(resetPowerBiEmbedToken());
                    dispatch(hideModal());
                    return;
                }
                if (viewAsAccount?.ipName && viewAsAccount?.accountId && hasAnyValidValue(viewAsAccount.ipiNumber, viewAsAccount.accountNumber)) {
                    dispatch(setCurrentUserNameNumber({
                        ipNameNumber: viewAsAccount.ipiNumber,
                        ipBaseNumber: DEFAULT_IP_BASE_NUMBER,
                        accountNumber: viewAsAccount.accountNumber,
                        userName: viewAsAccount.ipName,
                        guid: viewAsAccount.accountId,
                    }));
                }
                return dispatch<any>(getUserCRMValuesThunk())
                    .then(() =>
                        dispatch<any>(
                            fetchMembersPortalUserRolesThunk(portalType)
                        )
                    )
                    .then(() => {
                        dispatch(resetPowerBiEmbedToken());
                        dispatch(hideModal());
                    });
            })
            .catch(err => {
                dispatch(saveViewAsAccessFailure(err));
                dispatch(hideModal());
            });
    };
};

export const cancelAccessRequestThunk = (
    accountNumber: string,
    userName: string
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(cancelAccessRequest());
        dispatch(showLoading());

        return AccountService.cancelAccessRequest(accountNumber, userName)
            .then((res: boolean) => {
                dispatch(cancelAccessRequestSuccess(res, accountNumber));
                dispatch(hideModal());
            })
            .catch(err => {
                dispatch(cancelAccessRequestFailure(err));
                dispatch(hideModal());
            });
    };
};

export const getMyApplicationsThunk = (
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getMyApplications());

        return AccountService.getMyApplications()
            .then((res: IApplication[]) => {
                dispatch(getMyApplicationsSuccess(res));
            })
            .catch(err => {
                dispatch(getMyApplicationsFailure(err));
            });
    };
};

export const getMyCasesThunk = (
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getMyCases());

        return AccountService.getMyCases()
            .then((res: ICase[]) => {
                dispatch(getMyCasesSuccess(res));
            })
            .catch(err => {
                dispatch(getMyCasesFailure(err));
            });
    };
};

export const getCurrentUserSocietyAffiliationThunk = (
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        return AccountService.getCurrentUserSocietyAffiliation()
            .then((res: IAccountSocietyAffiliation) => {
                dispatch(setAccountSocietyAffiliation(res));
            });
    };
};

export const getMemberStatementDetailsThunk = (
    paymentSearchResult: IMemberStatementSearchResult,
    lookupValues: ILookupDictionary,
    userNameNumber: string,
    formats?: FormatFields[],
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        let res = paymentSearchResult;
        dispatch(showLoading());

        let memberStatementDetailsTab: ITabReduxItem = {
            title: res.paymentRunCode,
            tabTitle: res.paymentRunCode,
            component: MEMBER_STATEMENTS_DETAILS_PAGE.component,
            name: "memberStatementsSearch",
            memberStatementDetailsState: {
                loaded: false,
                payment: res,
                refreshKey: Date.now(),
            },
            changesMade: false,
            formatFields: formats
        };
        dispatch(mp_addTab(memberStatementDetailsTab));
        dispatch(hideModal());
    }
}

export const getMemberStatementPowerBiEmbedThunk = (
    reportid: string,
    queryParameter: string
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(showLoading());
        return MembersPortalService.getPowerBIEmbed(reportid, queryParameter)
            .then((res) => {
                dispatch(getMemberStatementPowerBiEmbedSuccess(res));
            })
            .catch(err => {
                dispatch(getMemberStatementPowerBiEmbedFailure(err));
            })
            .finally(() => {
                dispatch(hideModal());
            });
    }
}

export const searchLivePerformancesThunk = (
    livePerformancesQuery: ILivePerformanceSearchQuery
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(searchLivePerformancesRequest());

        return SearchRequests.getLivePerformances(livePerformancesQuery)
            .then((result: ILivePerformancesSearchResult) => {
                dispatch(searchLivePerformancesSuccess(result));
            }).catch(err => {
                dispatch(searchLivePerformancesFailure(err));
            });
    };
};

export const getLivePerformanceDetailsThunk = (
    usageId: string,
    formats?: FormatFields[]
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getDraftSetListDetailsRequest())
        dispatch(showLoading());
        return SearchRequests.getLivePerformance(usageId)
            .then((res: IUsageGroup) => {
                dispatch(getLivePerformanceDetailsSuccess(res));
                let newLivePerformanceTab: ITabReduxItem = {
                    title: UsageDetailsMapper.getUsageTitle(res),
                    component: LIVE_PERFORMANCE_MAINTENANCE_PAGE.component,
                    name: "livePerformanceSubmission",
                    livePerformanceMaintenanceState: {
                        loaded: false,
                        usageGroup: UsageDetailsMapper.mapUsageToState(res, [], [], true),
                        dataSource: undefined
                    },
                    changesMade: false,
                    formatFields: formats
                };
                dispatch(mp_addTab(newLivePerformanceTab, true));
                dispatch(hideModal());
            })
            .catch(err => {
                dispatch(getLivePerformanceDetailsFailure(err, usageId));
                dispatch(hideModal());
            });
    };
}

export const getShareDecimalsToDisplayThunk = (): ThunkAction<
    void,
    IAppState,
    null,
    Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getShareDecimalsToDisplayRequest());
        return SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_SHARE_DECIMALS_TO_DISPLAY, WORK_MAINTENANCE_GROUP)
            .then((res: number) => {
                dispatch(getShareDecimalsToDisplaySuccess(res));
            })
            .catch((error: any) => {
                dispatch(getShareDecimalsToDisplayFailure(error));
            });
    }
}

export const refreshWorkDetailsThunk = (
    dataSource: string,
    workID: number,
    lookups: ILookupDictionary,
    otherIndicatorsWorkFlagTypes: string[],
    activeTabItem: ITabReduxItem,
    formats: FormatFields[],
    readonlyIndicatorsWorkFlagTypes: string[]
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(refreshWorkDetailsRequest());
        dispatch(showLoading());
        return SearchRequests.getDraftWork(dataSource, workID)
            .then((res: IWork) => {
                dispatch(refreshWorkDetailsSuccess(res));
                let tab: ITabReduxItem = {
                    ...activeTabItem,
                    title: WorkDetailsMapper.getOriginalFullTitleFromWorkNames(res.workNames, res.workID),
                    draftWorkMaintenanceState: {
                        ...activeTabItem.draftWorkMaintenanceState,
                        loaded: false,
                        work: WorkDetailsMapper.mapWorkToWorkState(res, lookups, otherIndicatorsWorkFlagTypes, readonlyIndicatorsWorkFlagTypes),
                        isNew: false
                    },
                    changesMade: false
                };
                dispatch(replaceTab(tab, activeTabItem.title))
                dispatch(hideModal());
            })
            .catch(err => {
                dispatch(hideModal());
                dispatch(refreshWorkDetailsFailure(err, workID));
                if (err == 404) {
                    dispatch(showModal(WORK_NOT_FOUND_VIEW, null, workID, true, "Work not found"));
                }
            });
    };
};

export const refreshAgreementDetailsThunk = (
    dataSource: string,
    agreementID: number,
    activeTabItem: ITabReduxItem,
    formats: FormatFields[],
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(refreshAgreementDetailsRequest());
        dispatch(showLoading());
        return SearchRequests.getDraftAgreement(dataSource, agreementID)
            .then((res: IAgreement) => {
                dispatch(refreshAgreementDetailsSuccess(res));
                let tab: ITabReduxItem = {
                    ...activeTabItem,
                    title: AgreementDetailsMapper.getDraftAgreementTitle(res),
                    agreementMaintenanceState: {
                        loaded: false,
                        agreement: AgreementDetailsMapper.mapAgreementToState(res),
                        agreementBatchOperationInProgress: false
                    },
                    changesMade: activeTabItem.changesMade,
                    validationMessages: undefined,
                    saveSuccessful: undefined,
                    postSuccessful: undefined,
                    formatFields: formats
                };
                dispatch(replaceTab(tab, activeTabItem.title))
                dispatch(hideModal());
            })
            .catch(err => {
                dispatch(hideModal());
                dispatch(refreshAgreementDetailsFailure(err, agreementID));
                if (err == 404) {
                    dispatch(showModal(WORK_NOT_FOUND_VIEW, null, agreementID, true, "Work not found"));
                }
            });
    };
};

export const removeAgreementAttachmentIfExistsThunk = (attachedFile: IAttachedFile, source: DataSource, tabId?: string): ThunkAction<
    void,
    IAppState,
    null,
    Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(removeAgreementAttachmentRequest());
        const model: IAddAgreementAttachmentModel = {
            attachedFile: attachedFile,
            dataSource: source
        }
        return MembersPortalService.removeAgreementAttachment(model)
            .then((res: boolean) => {
                if (res) {
                    dispatch(removeAgreementAttachmentSuccess(model.attachedFile, tabId));
                }
            })
            .catch((error: any) => {
                dispatch(removeAgreementAttachmentFailure(error));
            });
    }
}


export const getCRMIntegratedEnabledThunk = (): ThunkAction<
    void,
    IAppState,
    null,
    Action<string>> => {
    return (dispatch: Dispatch) => {
        return SearchRequests.getConfigurationParameter(CRM_INTEGRATED_KEY, CUSTOMER_GROUP)
            .then((res: any) => {
                if (res == 1) {
                    SearchRequests.getConfigurationParameter(POWER_PORTAL_BASE_URL_KEY, CUSTOMER_GROUP)
                        .then((res: any) => {
                            dispatch(getCRMPowerPortalURLSuccess(res));
                            AccountService.getMyApplications()
                                .then((res: IApplication[]) => {
                                    dispatch(getMyApplicationsSuccess(res));
                                    AccountService.getMyCases()
                                        .then((res: ICase[]) => {
                                            dispatch(getMyCasesSuccess(res));
                                        })
                                        .catch(err => {
                                            dispatch(getMyCasesFailure(err));
                                        });
                                })
                        })
                        .then(() => {
                            dispatch(getCRMIntegratedEnabledSuccess(res));
                        })
                        .catch(err => {
                            dispatch(getMyApplicationsFailure(err));
                        });
                }
                else {
                    dispatch(getCRMIntegratedEnabledSuccess(res));
                }
            })
            .catch((error: any) => {
                dispatch(getCRMIntegratedEnabledFailure(error));
            });
    }
}

export const getAssigneeAgreementsThunk = (
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(getAssigneeAgreementsRequest())
        return SearchRequests.getAssigneeAgreements()
            .then((result: IAssigneeAgreementResult[]) => {
                dispatch(getAssigneeAgreementsSuccess(result));
            }).catch(err => {
                dispatch(getAssigneeAgreementsFailure(err));
            });
    };
}

async function hydrateProductWorksFromIndex(workIDs: number[], dataSource: string, productWorks: IProductWork[]): Promise<IProductWork[]> {
    return new Promise<IProductWork[]>(async (resolve, reject) => {
        const productWorksToReturn: IProductWork[] = [];
        const workSearchQuery: IMatchWorksSearchQuery =
        {
            workIDs: workIDs,
            title: "",
            number: "",
            artist: "",
            writers: "",
            societyAccountNumber: "",
            workBatchID: "",
            dataSource: dataSource,
            hasOpenWorkflow: false
        };

        await SearchRequests.getSetListWorks(workSearchQuery)
            .then((result: IMatchWorksSearchResult[]) => {
                result.forEach((w) => {
                    const currentProductWorks: IProductWork[] = productWorks.filter(x => x.workCode === w.workID);

                    currentProductWorks.forEach(currentProductWork => {
                        let status = "Registered";
                        if (w.dataSource == "Intray") {
                            if (w.isDraftSubmitted)
                                status = "Draft Submitted";
                            else status = "Draft";
                        }
                        const hydratedWork: IProductWork = {
                            productWorkID: currentProductWork.productWorkID,
                            workDataSource: dataSource,
                            duration: currentProductWork.duration,
                            workCode: currentProductWork.workCode,
                            musicUsage: currentProductWork.musicUsage,
                            title: w.title.find(t => t !== undefined && t != null) ?? "",
                            number: w.number.find(t => t !== undefined && t != null) ?? "",
                            writer: w.writers.find(t => t !== undefined && t != null) ?? "",
                            artist: w.artists.find(a => a != undefined && a != null) ?? "",
                            status,
                            order: currentProductWork.order
                        }
                        productWorksToReturn.push(hydratedWork);
                    });
                });
                return resolve(productWorksToReturn);

            })
            .catch(err => {
                reject(err);
            });
    });
}

export const fetchMembersPortalUserRolesThunk = (portalType: string): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        return MembersPortalService.fetchMembersPortalUserRoles(portalType)
            .then((roles: Record<string, IMembersPortalRoleAssignment>) => {
                sessionStorage.setItem("membersPortalUserRoles", JSON.stringify(roles));
                dispatch<any>(getMenuItemsThunk(portalType));
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

export const getPowerBIConfigurationThunk = (): ThunkAction<
    void,
    IAppState,
    null,
    Action<string>> => {
    return (dispatch: Dispatch) => {
        return SearchRequests.getConfigurationParameter(ENABLE_POWER_BI_EMBEDDED_KEY, CUSTOMER_GROUP)
            .then((res: any) => {
                if (res) {
                    return SearchRequests.getConfigurationParameter(POWER_BI_ANALYTICS_CONFIGURATION_KEY, PORTAL_CONFIGURATION_GROUP)
                        .then((res: any) => {

                            const powerBIAnalyticsConfig: IPowerBIAnalyticsConfig[] = res.map((item: any) => ({
                                reportId: item.ReportId,
                                reportName: item.ReportName,
                                queryParameter: item.QueryParameter
                            }));

                            dispatch(getPowerBIConfigurationSuccess(powerBIAnalyticsConfig));
                        })
                        .catch((error: any) => {
                            dispatch(getPowerBIConfigurationFailure(error));
                        });
                }
            }).catch((error: any) => {
                dispatch(getPowerBIConfigurationFailure(error));
            });
    }
}

export const getPortalWorkStatusConfigurationThunk = (): ThunkAction<
    void,
    IAppState,
    null,
    Action<string>> => {
    return (dispatch: Dispatch) => {
        return SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_PORTAL_WORK_STATUS_CONFIGURATION, PORTAL_CONFIGURATION_GROUP)
            .then((res: any) => {
                const configuration: IPortalWorkStatusConfiguration = {
                    mappings: (res?.Mappings ?? []).map((mapping: any) => ({
                        portalStatusCode: mapping.PortalStatusCode,
                        portalDisplayName: mapping.PortalDisplayName,
                        backOfficeStatusCodes:
                            mapping.BackOfficeStatusCodes ?? []
                    })),
                    excludedBackOfficeStatuses:
                        res?.ExcludedBackOfficeStatuses ?? []
                };

                dispatch(
                    getPortalWorkStatusConfigurationSuccess(configuration)
                );
            })
            .catch((error: any) => {
                dispatch(
                    getPortalWorkStatusConfigurationFailure(error)
                );
            });
    };
};